#!/usr/bin/env node
import fs from 'fs';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';
import { importMap, headLinks, footLinks } from './consts.js';
import { importMapOverride } from './consts-override.js';
import { transformImportMap } from './transform.js';

yargs(hideBin(process.argv))
  .command(
    'write-import-map',
    'write import map to entry HTML',
    {
      cdn: {
        default: 'https://cdn.jsdelivr.net/npm',
        description: 'default CDN url',
      },
      'latest-packages': {
        default: false,
        description: 'get or remove version numbers (remove for local dev)',
      },
      'npm-version-semver': {
        default: 'latest',
        description: 'semver version to be used to get latest version from npm',
      },
      target: {
        default: 'src/index.html',
        description: 'File to be written with import-map',
      },
      'original-target': {
        default: 'src/index-original.html',
        description: 'File to be read',
      },
    },
    async argv => {
      const { target } = argv;
      const originalTarget = argv['original-target'];
      const replaceCdnStr = '{{NPM_CDN}}';
      const enconding = 'utf8';

      let updatedHeadLinks = headLinks;
      if (argv['latest-packages']) {
        try {
          updatedHeadLinks = await transformImportMap(
            importMap,
            headLinks,
            argv['npm-version-semver'],
          );
        } catch (error) {
          console.error(error);
          process.exit(1);
        }
      }

      const importMapOverriden = {
        imports: {
          ...importMap.imports,
          ...importMapOverride.imports,
        },
        scopes: {
          ...importMap.scopes,
        },
      };

      let importMapString = `${updatedHeadLinks} <script type="importmap">${JSON.stringify(importMapOverriden, null, 2)}</script>`;
      let originalHtml = fs.readFileSync(originalTarget, enconding);
      importMapString = importMapString.replaceAll(replaceCdnStr, argv.cdn);

      // either remove the pipe's or remove the pipes and everything between them
      // this is because unpkg will resovle a versionless request to the latest available
      // which is usefull for local development because we use unpkg and are not concerned with versions
      importMapString = importMapString.replaceAll(
        new RegExp(argv['latest-packages'] ? '\\|\\|' : '\\|\\|.*?\\|\\|', 'g'),
        '',
      );
      originalHtml = originalHtml.replace(
        '<!-- import map -->',
        importMapString,
      );
      originalHtml = originalHtml.replace(
        '<!-- footer links -->',
        footLinks.replaceAll(replaceCdnStr, argv.cdn),
      );

      fs.writeFileSync(target, originalHtml, enconding);
    },
  )
  .parse();
